"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGenericMessageValidator = exports.default = exports.ValidationMessages = exports.GenericErrorMessages = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _errorMessage = require("@hookform/error-message");
var _Icon = require("../../UIElements/Icons/PetSure/Icon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GenericErrorMessages = exports.GenericErrorMessages = {
  'required': () => 'This field is required. Please enter a value.',
  'minLength': value => "Please provide a minimum of ".concat(value, " characters."),
  'maxLength': value => "Please provide a maximum of ".concat(value, " characters."),
  'min': value => "The value must be a minimum of ".concat(value, "."),
  'max': value => "The value must be a maximum of ".concat(value, "."),
  'unknown': () => 'An unknown error has occurred.'
};
const extractError = (errors, fieldName) => {
  if (!errors) {
    return null;
  }
  const pathComponents = fieldName.split('.');
  return pathComponents.reduce((accumulator, pathComponent) => {
    if (!accumulator) {
      return null;
    }
    return accumulator[pathComponent];
  }, errors);
};
const isGenericMessageValidator = (validatorKey, validator) => {
  const isValidatorWithParameter = ['min', 'max', 'minLength', 'maxLength'].includes(validatorKey);
  return isValidatorWithParameter && validator.value !== undefined || validatorKey === 'required' || validatorKey === 'unknown';
};
exports.isGenericMessageValidator = isGenericMessageValidator;
const ValidationMessages = _ref => {
  let {
    formContext,
    name,
    validation
  } = _ref;
  if (!formContext) {
    return null;
  }
  const {
    formState: {
      errors
    }
  } = formContext;
  const fieldError = extractError(errors, name);
  if (!fieldError) {
    return null;
  }

  // Check all the validators have a message
  if (validation) {
    Object.entries(validation).forEach(_ref2 => {
      let [validatorKey, validator] = _ref2;
      if (typeof validator !== 'string' && !validator.message) {
        if (GenericErrorMessages[validatorKey]) {
          if (typeof validator === 'boolean') {
            // eslint-disable-next-line no-param-reassign
            validator = {
              type: validatorKey
            };
          }
          if (isGenericMessageValidator(validatorKey, validator)) {
            validator.message = GenericErrorMessages[validatorKey](validator.value);
            if (fieldError.type === validatorKey) {
              fieldError.message = validator.message;
            }
          }
        }
      }
    });
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "validation",
    id: "".concat(name, "_errors")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "message"
  }, !(fieldError !== null && fieldError !== void 0 && fieldError.message) && /*#__PURE__*/_react.default.createElement("span", {
    className: "error"
  }, GenericErrorMessages.unknown()), /*#__PURE__*/_react.default.createElement(_errorMessage.ErrorMessage, {
    errors: errors,
    name: name,
    render: _ref3 => {
      let {
        message
      } = _ref3;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
        icon: "error"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "error"
      }, message));
    }
  })));
};
exports.ValidationMessages = ValidationMessages;
ValidationMessages.propTypes = {
  name: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  validation: _propTypes.default.any,
  // eslint-disable-next-line react/forbid-prop-types
  formContext: _propTypes.default.any
};
var _default = exports.default = ValidationMessages;